import { NavItem } from './Header.types';

export const navItems: NavItem[] = [
  { href: '/applications', label: 'Applications' },
  // { href: '/bounties', label: 'Bounties' },
];

export const isActivePath = (pathname: string, href: string) => {
  if (pathname === href) return true;
  const item = navItems.find((item) => item.href === href);
  if (!item || !item.associatedRoutes) return false;
  return item.associatedRoutes.some((regexp) => regexp.test(pathname));
};
